import React from "react";
import { style, classes } from "./componentmenu.st.css";
// Component
import Nav from "../../../components/Nav/Nav";

const publicUrl = process.env.PUBLIC_URL;

const navLinks = [
  {
    linkText: "Alert",
    url: `${publicUrl}/components/alert`
  },
  {
    linkText: "Body",
    url: `${publicUrl}/components/body`
  },
  {
    linkText: "Brand",
    url: `${publicUrl}/components/brand`
  },
  {
    linkText: "Breadcrumb",
    url: `${publicUrl}/components/breadcrumb`
  },
  {
    linkText: "Button",
    url: `${publicUrl}/components/button`
  },
  {
    linkText: "Campaign Monitor",
    url: `${publicUrl}/components/campaign-monitor`
  },
  {
    linkText: "Chip",
    url: `${publicUrl}/components/chip`
  },
  {
    linkText: "Chip Group",
    url: `${publicUrl}/components/chip-group`
  },
  {
    linkText: "Cookie Banner",
    url: `${publicUrl}/components/cookie-banner`
  },
  {
    linkText: "Container",
    url: `${publicUrl}/components/container`
  },
  {
    linkText: "Divider",
    url: `${publicUrl}/components/divider`
  },
  {
    linkText: "Download",
    url: `${publicUrl}/components/download`
  },
  {
    linkText: "Drop",
    url: `${publicUrl}/components/drop`
  },
  {
    linkText: "Footer",
    url: `${publicUrl}/components/footer`
  },
  {
    linkText: "Form",
    url: `${publicUrl}/components/form`
  },
  {
    linkText: "Form Error Message",
    url: `${publicUrl}/components/form-error-message`
  },
  {
    linkText: "Form Group",
    url: `${publicUrl}/components/form-group`
  },
  {
    linkText: "Form Help Text",
    url: `${publicUrl}/components/form-help-text`
  },
  {
    linkText: "Form Input",
    url: `${publicUrl}/components/form-input`
  },
  {
    linkText: "Form Label",
    url: `${publicUrl}/components/form-label`
  },
  {
    linkText: "Form Select",
    url: `${publicUrl}/components/form-select`
  },
  {
    linkText: "Form Text Area",
    url: `${publicUrl}/components/form-text-area`
  },
  {
    linkText: "Header",
    url: `${publicUrl}/components/header`
  },
  {
    linkText: "Hero",
    url: `${publicUrl}/components/hero`
  },
  {
    linkText: "Icon",
    url: `${publicUrl}/components/icon`
  },
  {
    linkText: "Image",
    url: `${publicUrl}/components/image`
  },
  {
    linkText: "Link",
    url: `${publicUrl}/components/link`
  },
  {
    linkText: "Listing",
    url: `${publicUrl}/components/listing`
  },
  {
    linkText: "Media",
    url: `${publicUrl}/components/media`
  },
  {
    linkText: "Nav",
    url: `${publicUrl}/components/nav`
  },
  {
    linkText: "Newsletter Sign Up",
    url: `${publicUrl}/components/newsletter-sign-up`
  },
  {
    linkText: "Newsletter Success",
    url: `${publicUrl}/components/newsletter-success`
  },
  {
    linkText: "Pagination",
    url: `${publicUrl}/components/pagination`
  },
  {
    linkText: "Panel",
    url: `${publicUrl}/components/panel`
  },
  {
    linkText: "Person",
    url: `${publicUrl}/components/person`
  },
  {
    linkText: "Promo List",
    url: `${publicUrl}/components/promo-list`
  },
  {
    linkText: "Search",
    url: `${publicUrl}/components/search`
  },
  {
    linkText: "Search Results",
    url: `${publicUrl}/components/search-results`
  },
  {
    linkText: "Secondary Nav",
    url: `${publicUrl}/components/secondary-nav`
  },
  {
    linkText: "Single Promo",
    url: `${publicUrl}/components/single-promo`
  },
  {
    linkText: "Sitemap",
    url: `${publicUrl}/components/sitemap`
  },
  {
    linkText: "Skip Link",
    url: `${publicUrl}/components/skip-link`
  },
  {
    linkText: "Social",
    url: `${publicUrl}/components/social`
  },
  {
    linkText: "Text",
    url: `${publicUrl}/components/text`
  },
  {
    linkText: "Tiled List",
    url: `${publicUrl}/components/tiled-list`
  }
];

const ComponentMenu = ({ className }) => {
  return (
    <div className={style(classes.root, className)}>
      <Nav items={navLinks} className={classes.sideNav} />
    </div>
  );
};

export default ComponentMenu;
